<div class="back-image" style="transform: translate3d(0px, 105px, 0px)">
	<picture>
		<source type="image/webp" srcset="assets/images/ui/Stars-6.png.webp" />
		<img src="assets/images/ui/Stars-6.png" alt="Stars" />
	</picture>
</div>
